<h3 mat-dialog-title>Cadastro Simplificado do Cliente</h3>
<div mat-dialog-content>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%" appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Nome Completo</mat-label>
                <input 
                    matInput 
                    placeholder="Nome Completo" 
                    [formControl]="nome" 
                    required
                    maxlength="255">
                <mat-error *ngIf="nome.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%" fxLayoutAlign="space-between center">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Data de Nascimento</mat-label>
                <input 
                    matInput 
                    [matDatepicker]="picker" 
                    [formControl]="data_nascimento"                     
                    name="data_nascimento" 
                    placeholder="Data de Nascimento">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Estado Civil</mat-label>
                <mat-select                     
                    [(value)]="model.estado_civil_id" 
                    [formControl]="estado_civil_id"
                    name="estado_civil_id">
                    <mat-option value="">Selecione</mat-option>
                    <mat-option 
                        *ngFor="let estadoCivil of listEstadoCivil" 
                        [value]="estadoCivil.id">
                        {{estadoCivil.nome}}
                    </mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerEstadoCivil"></mat-spinner>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%" fxLayoutAlign="space-between center">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Sexo</mat-label>
                <mat-select 
                    [(value)]="model.sexo" 
                    [formControl]="sexo"
                    required
                    name="sexo">
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option value="M">Masculino</mat-option>
                    <mat-option value="F">Feminino</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Cliente Prospect</mat-label>
                <mat-select 
                    [(value)]="model.prospect" 
                    required
                    name="prospect"
                    [formControl]="prospect"
                >
                    <mat-option value="">SELECIONE</mat-option>
                    <mat-option value="true">Sim</mat-option>
                    <mat-option value="false">Não</mat-option>
                </mat-select>
            </mat-form-field>   
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%" fxLayoutAlign="space-between center">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Profissão</mat-label>
                <mat-select 
                    placeholder="Profissão"
                    [(value)]="model.profissao_id" 
                    [formControl]="profissao_id"
                    name="profissao_id">
                    <mat-option value="">Selecione</mat-option>
                    <mat-option 
                        *ngFor="let profissao of listProfissao" 
                        [value]="profissao.id">
                        {{profissao.nome}}
                    </mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerProfissao"></mat-spinner>
            </mat-form-field>

            <mat-form-field appearance="outline" floatLabel="always" fxFlex="49">
                <mat-label>Telefone</mat-label>
                <input 
                    matInput 
                    placeholder="Telefone"
                    [formControl]="telefone"
                    name="telefone"                    
                    mask="(00) 00000-0000">
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">            
            <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
                <mat-label>Assessor</mat-label>                                        
                <mat-select 
                    placeholder="Assessor"
                    [(value)]="model.assessor_id" 
                    [formControl]="assessor_id"
                    required 
                    name="assessor_id">
                    <mat-option value="">Selecione...</mat-option>
                    <mat-option *ngFor="let assessor of listAssessor" [value]="assessor.id">{{assessor.name}}</mat-option>
                </mat-select>
                <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>
                <mat-error *ngIf="assessor_id.invalid">{{getErrorAssessorMessage()}}</mat-error>
            </mat-form-field>            
        </div>
    </div>

    
</div>

<div mat-dialog-actions>
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()">
        Cancelar
    </button>
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()"
        tabindex="-1">
        Salvar
    </button>
</div>